import styled from "styled-components";
import Button from "./Button";
import {mq} from "./util/media";
import { useEffect, useState } from "react";
import { ReactComponent as MobileMenuIcon } from "../images/mobile_menu.svg";
import { ReactComponent as MenuCloseIcon } from "../images/x.svg";
import anime from "animejs";

import { ReactComponent as BrandLogo } from "../images/logo_large.svg"

const HeaderWrapper = styled.header`
  font-size: 1.1rem;
  z-index: 2;

  height: 120px;
  ${mq.lt.md} {
    height: auto;
    padding-top: 24px;
  }
  background: black;

  display: flex;
  align-items: center;

  width: 100%;
  
  margin: 0 auto;
  ${mq.gt.md} {
    padding-top: 64px;
  }

  opacity: 0;
`

const HeaderInner = styled.div`
  width: 100%;

  ${mq.gt.xs} {
    padding: 0 1rem;
  }
  max-width: 1200px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin:0 auto;

  a:not(.btn) {
    color: #675F5F;
    text-decoration: none;
    text-transform: uppercase;
  }
`

const Nav = styled.nav`
  ul {
    display: flex;
    justify-content: space-between;
    gap: 3rem;
    font-size: 15px;
  }

  li {
    display: flex;
    align-items: center;
    font-weight: 510;
  }

  ${mq.lt.sm} {
    position: fixed;
    top: 0;
    right: 0;
    width: 100%;
    background: black;
    padding-right: 2rem;
    transform: translateY(-100%);
    transition: 0.5s ease-in-out;

    &.show {
      transform: translateX(0);
    }


    ul {
      margin-top: 100px;
      gap: 1rem;
    }

    li > * {
        font-size: 1rem;
      }
  }

  ${mq.lt.sm} {
      li > * {
        font-size: 9px;
      }
    }
`

const Title = styled.span`
  font-weight: bold;
  font-size: 18px;

  ${mq.lt.md} {
    font-size: 1em;
  }

  ${mq.lt.sm} {
    font-size: 9px;
  }

  & a {
    height: fit-content;
    display: block;
  }
`

const BrandLogoContainer = styled.div`
  width: 100%;
  position: relative;
  max-width: 85px;
  z-index: 1;

  & svg {
    width: 100%;
    height: 100%;
    fill: white;
  }

  ${mq.gt.xs} {

    & svg {
      fill: #676060;
    }
  }

  ${mq.gt.sm} {
    max-width: 185px;
    padding: 28px;
  }
`

const MobileButton = styled.button`
  z-index: 5;

  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  padding: 0;
  background: none;
  border: none;
  height: 24px;
  width: 24px;
  color: white;

  & svg {
    width: 100%;
    height: 100%;
    fill: currentColor;
    stroke: currentColor;
  }

  ${mq.gt.xs} {
    display: none;
  }
  

`

function Header ({loading}) {

  const [showNav, setShowNav] = useState(false);

  useEffect(() => {
    if(loading === false) {
      if (document.visibilityState === "visible") {
  
        anime({
          targets: 'header',
          opacity: [0, 1],
          duration: 1000,
          easing: 'easeInOutQuad'
        })
      } else {
        document.querySelector('header').style.opacity = 1;
      }
    }
  }, [loading])

  return (
    <HeaderWrapper>
      <HeaderInner>

      <Title>
        <a href="/">
          <BrandLogoContainer>
            <BrandLogo />
          </BrandLogoContainer>
        </a>
      </Title>

        <MobileButton onClick={()=> {
          setShowNav(!showNav)
        }}>
          {showNav ? <MenuCloseIcon /> : <MobileMenuIcon />}
        </MobileButton>

        <Nav className={`nav-container ${showNav ? 'show' : ''}`}>
          
          <ul>
            <li>
              <a href="/webapp" target="_blank" rel="noreferrer">Dashboard</a>
            </li>
            <li>
              <a href="https://neartreasury.io/docs/NearTreasuryLitepaper.pdf" target="_blank" rel="noreferrer">Litepaper</a>
            </li>
            <li>
              <Button link="/webapp" type="webapp">WebApp</Button>
            </li>
          </ul>
        </Nav>
      </HeaderInner>
    </HeaderWrapper>
  )
}

export default Header;